import { render, staticRenderFns } from "./sendGiftModal.vue?vue&type=template&id=6e04f260&scoped=true"
import script from "./sendGiftModal.vue?vue&type=script&lang=js"
export * from "./sendGiftModal.vue?vue&type=script&lang=js"
import style0 from "./sendGiftModal.vue?vue&type=style&index=0&id=6e04f260&prod&lang=scss"
import style1 from "./sendGiftModal.vue?vue&type=style&index=1&id=6e04f260&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04f260",
  null
  
)

export default component.exports